import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

import { usersProfile_template } from "../components/templates/usersProfile_template";
import { vnApp_sentinelbi } from "../components/vnApp_sentinelbi";

declare var ko: any;
declare var page: any;
declare var Dropzone: any;

interface RememberedBrowser {
    id: number;
    deviceName: string | null;
    browser: string | null;
    operatingSystem: string | null;
    ipAddress: string | null;
    dateCreation: string;
    dateLastUsed: string;
    dateExpires: string;
    status: 'Active' | 'Expired' | 'Revoked';
    isCurrent: boolean;
}
interface RememberedBrowserResponse {
    enabled: boolean;
    devices: RememberedBrowser[];
    csrfToken?: string;
}

export class users_profile extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected userProfile: usersProfile_template;
    private rememberedDevicesCsrf: string = '';

    protected getModuleName(){
        return "users_profile";
    }

    buildContent() : Array<Element>{
        // create the users form
        this.userProfile = new usersProfile_template("userProfile", this.viewModel, this);

        return [ this.userProfile.build()];
    }

    fillPage() : void{
        this.getPermissions();
        this.getFormData();
    }

    protected editUser(idUser){
        page.redirect('/user/edit/' + idUser)
    }

    // protected onClickBack(){

    //     let redirectUrl = '/'; 
    //     const userEditPageRegex = /\/user\/edit\/\d+/;
    //     const userProfilePageRegex = /\/user\/profile\/\d+/

    //     for (var i = this.getVnAppZone().app.routeHistory.length - 1; i >= 0; i--) {

    //         if (!userEditPageRegex.test(this.getVnAppZone().app.routeHistory[i]) &&) {

    //             redirectUrl = this.getVnAppZone().app.routeHistory[i];
    //             break;
    //         }
    //     }
    //     page.redirect(this.getVnAppZone().app.getLastRoute());
    // }


    //
    // obtain the dynamic data required to fill the formulary
    protected getFormData(){
        this.loadingIn(this.userProfile.builtTemplate);

        let id: number;
        let action: string;

        if( (id = this.getVnAppZone().app.params.id) && !isNaN(id)) {
            this.viewModel["userProfile"].idUser(id);
        }

        let usrReq_url: string = '/api/settings/user/dataWithoutLocker/' + id + "/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.viewModel["userProfile"])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();
    }

    protected getPermissions(){

        this.loadingIn(this.userProfile.builtTemplate);

        let accPermissions_url: string = '/api/settings/menuData';
        let accPermissions_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(accPermissions_url, accPermissions_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetPermissionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetPermissionsReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.loadingOut(obj.userProfile.builtTemplate);
                obj.userProfile.setSideMenuPermissionsData(responseParsed);
            })
        }
    }

    //
    // use the form data to fill the form
    protected onGetFormDataReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let thisModule = (<users_profile>obj);
                let responseParsed = JSON.parse(req.request.response);

                let vnApp = thisModule.getVnAppZone().app as vnApp_sentinelbi;
                let user = responseParsed.data.user;
                let permissions = responseParsed.permissions;

                if (user.vnAppUser.id !== undefined && user.vnAppUser.id !== null) {

                    obj.userProfile.setRoles(user.vnAppUser.roles);
                    obj.userProfile.setBrands(user.brands);
                    obj.updateElementForm(user, obj);

                    // role checking for showing/hiding edit button for the user
                    const userRoles = user.user.roles.map(r => r.id);
                    const userIsAdmin = obj.hasRole(userRoles, vnApp_sentinelbi.ROLE_ADMINISTRATOR);
                    const userIsOwner = obj.hasRole(userRoles, vnApp_sentinelbi.ROLE_OWNER);

                    const canEditAsAdminOrOwner = vnApp.isOfRole(vnApp_sentinelbi.ROLE_ADMINISTRATOR) || (vnApp.isOfRole(vnApp_sentinelbi.ROLE_OWNER) && !userIsAdmin);

                    obj.userProfile.setHasWriteAccess(((canEditAsAdminOrOwner) || (permissions['user_edit_self'].write && user.id == vnApp.loggedUser.user.id) || (permissions['user_edit_advanced'].write && !(userIsAdmin || userIsOwner))));
                    obj.userProfile.setPermissions(permissions);
                    if (user.id == vnApp.loggedUser.user.id) {
                        thisModule.getRememberedDevices();
                    }
                }

                if(req.request.readyState == 4){

                    obj.loadingOut(obj.userProfile.builtTemplate);
                }
            });
        };
    }

    private async getRememberedDevices(): Promise<void> {
        const viewModel = this.userProfile.getTemplateViewModel();
        // Reset owner-specific state before loading the current profile's browser list.
        viewModel.rememberedDevicesEnabled(false);
        this.rememberedDevicesCsrf = '';
        try {
            const response = await fetch('/api/access/remembered-devices/', { credentials: 'same-origin', cache: 'no-store' });
            if (!response.ok) {
                throw new Error('Unable to load remembered browsers.');
            }
            const data: RememberedBrowserResponse = await response.json();
            viewModel.rememberedDevicesEnabled(data.enabled === true);
            this.rememberedDevicesCsrf = data.csrfToken || '';
            viewModel.rememberedDevices((data.devices || []).map(device => {
                const fields: Array<'dateCreation' | 'dateLastUsed' | 'dateExpires'> = ['dateCreation', 'dateLastUsed', 'dateExpires'];
                fields.forEach(field => {
                    device[field] = device[field] ? new Date(device[field]).toLocaleString() : '';
                });
                return device;
            }));
        } catch (error) {
            viewModel.rememberedDevicesMessage('Unable to load remembered browsers.');
        }
    }

    public async changeRememberedDevices(action: string, deviceId?: number): Promise<void> {
        const viewModel = this.userProfile.getTemplateViewModel();
        if (viewModel.rememberedDevicesBusy() || !this.rememberedDevicesCsrf) {
                return;
            }
        viewModel.rememberedDevicesBusy(true);
        try {
            const response = await fetch('/api/access/remembered-devices/', {
                method: 'POST', credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': this.rememberedDevicesCsrf },
                body: JSON.stringify({ action, deviceId })
            });
            const result: {success: boolean} = await response.json();
            if (!response.ok || !result.success) {
                throw new Error('Unable to update remembered browsers.');
            }
            viewModel.rememberedDevicesMessage('Remembered access updated. Current sessions stay open.');
            await this.getRememberedDevices();
        } catch (error) {
            viewModel.rememberedDevicesMessage('Unable to update remembered browsers. Please reload and try again.');
        } finally {
            viewModel.rememberedDevicesBusy(false);
        }
    }

    protected updateElementForm(user, thisModule: users_profile){
        thisModule.viewModel["userProfile"].idUser(user.id);
        thisModule.viewModel["userProfile"].firstName(user.vnAppUser.firstName);
        thisModule.viewModel["userProfile"].lastName(user.vnAppUser.lastName);
        thisModule.viewModel["userProfile"].loginName(user.vnAppUser.loginName);
        thisModule.viewModel["userProfile"].email(user.vnAppUser.email);
        thisModule.viewModel["userProfile"].pictureUrl((user.vnAppUser.pictureUrl) ? "/usersImages/" + user.vnAppUser.pictureUrl : "/assets/images/default-user.png");

        let isActive:string = (user.vnAppUser.isActive) ? "true" : "false";
        thisModule.viewModel["userProfile"].isActive(isActive);
    }

    private hasRole(userRoles: string[], roleToCheck: string) {
        return userRoles.some(r => r == roleToCheck);
    }
}



// WEBPACK FOOTER //
// ./js/modules/users_profile.ts